import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-lista-errores',
  templateUrl: './lista-errores.component.html',
  styleUrls: ['./lista-errores.component.css']
})
export class ListaErroresComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
